import { QuerySwitch } from 'components/QuerySwitch';
import { shiftModalRoutingService } from 'modals/ShiftModal/ShiftModal.ui.context';
import { useShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { useAssignToAgencyTeamMemberFormContext } from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/contexts/AssignToAgencyTeamMemberView.form.context';
import { FetchAgencyTeamMemberAvailabilityByOrderIdDataProvider } from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/contexts/FetchAgencyTeamMemberAvailabilityByOrderId.data.context';
import {
  FetchAgencyTeamMemberByIdDataContext,
  FetchAgencyTeamMemberByIdDataProvider,
} from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/contexts/FetchAgencyTeamMemberById.data.context';
import { AssignToAgencyTeamMemberSummaryViewComponent } from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/views/AssignToAgencyTeamMemberSummaryView/AssignToAgencyTeamMemberSummaryView.component';
import { FC, FormEvent } from 'react';
import {
  AssignToAgencyTeamMemberFetchAgencyJaneAvailabilityByJaneIdOrderIdQuery,
  Order,
} from 'types/graphql';

export const AssignToAgencyTeamMemberSummaryView: FC = () => {
  const { values, onSubmit } = useAssignToAgencyTeamMemberFormContext();
  const { data } = useShiftModalDataContext();
  const order = data?.order;

  /**
   * Done through onSuccess function passed into this validation query
   * -----------------------------------------------------------------
   * Upon successful validation of shift and team member availability, shift will be assigned and flow will be complete
   * Upon failed validation of shift and team member availability, user will be redirected to the unavailable view.
   */
  const onSuccess = (
    result: AssignToAgencyTeamMemberFetchAgencyJaneAvailabilityByJaneIdOrderIdQuery,
  ) => {
    const nodes = result?.requestAllJanes?.nodes;
    if (
      ((result?.node as Order).canAssign || (result?.node as Order).canB2bAssign) &&
      nodes?.length > 0
    )
      onSubmit({} as FormEvent<HTMLFormElement>);
    else shiftModalRoutingService.goToView('TeamMemberUnavailableView');
  };

  return (
    <FetchAgencyTeamMemberAvailabilityByOrderIdDataProvider
      onSuccess={onSuccess}
      janeId={values.janeId}
      orderRelayId={order.relayId}
      breakTime={order?.orderSchedule?.breakTime}
    >
      <FetchAgencyTeamMemberByIdDataProvider>
        <QuerySwitch
          component={() => <AssignToAgencyTeamMemberSummaryViewComponent />}
          context={FetchAgencyTeamMemberByIdDataContext}
        />
      </FetchAgencyTeamMemberByIdDataProvider>
    </FetchAgencyTeamMemberAvailabilityByOrderIdDataProvider>
  );
};
